<script>
import Empty from './empty'
// import { defineAsyncComponent } from "vue";
// const Empty = defineAsyncComponent(() => import("./empty.vue"));
import debounce from "lodash/debounce";
import axios from "axios";
import config from "./../config.js";
import Dropdown from "@/components/Form/components/classic-form-input/dropdown.vue";
import Input from "@/components/Form/components/classic-form-input/input.vue";

export default {
  props: [
    "value",
    "className",
    "type",
    "dontIncludeSubdistrict",
    "placeholder",
    'fieldLabel',
    'hasError',
    'showLabel',
    'rules',
    "fieldName",
    "addressVal",
    "isLabel",
    "formMode",
    "shippingData",
    "theme",
  ],
  data() {
    return {
      baseUrl: config.api.replace("/api", ""),
      keyword: "",
      searchData: "",
      autofillLoading: false,
      autoFillPayload: undefined,
      AutofillData: [],
      customerAUTOFILL: "",
      payload: {
        customerAUTOFILL: "",
        customerFULL_AUTOFILL: "",
        PROVINCE: "",
        DISTRICT: "",
        SUBDISTRICT: "",
        CITY: "",
        ZIP: "",
        ORIGIN_CODE: "",
        CODE_SAP: "",
        DESTINATION_CODE_SI: "",
        ORIGIN_CODE_SI: "",
        closedSi: "",
        unsupportedSi: "",
        CITY_NAME_SI: "",
      },
    };
  },
  mounted() {    
    const city=[],district=[],province=[];
    const params={ };

      if(this.shippingData && this.shippingData.enableExcludeShipping && this.shippingData.excludeShippingLocation && this.shippingData.excludeShippingLocation.length>0){
          this.shippingData.excludeShippingLocation.map(item=>{
              if(item.type=='province'){
                  province.push(item.PROVINCE_NAME);
              }else if(item.type=='city'){
                  city.push(item.item.CITY_NAME);
              }else if(item.type=='district'){
                  district.push(item.item.DISTRICT_NAME);
              }
          })
          params['province_filter']=province.join(",");
          params['city_filter']=city.join(",");
          params['district_filter']=district.join(",")
          params['excludeShipping']=this.shippingData.excludeShipping;     
          params['excludeShippingLocation']=this.shippingData.excludeShippingLocation;
      }
   
      this.handleAutofill = debounce(async function (val) {
      this.autofillLoading = true;
      this.AutofillData = [];
      if (val) {
        params.keyword = val
        this.keyword = val
      }
      let autofill = await axios.post(
        this.baseUrl + "api/address/autofill/province",
        { exact: true, ...params }
      );
      this.AutofillData = autofill.data.success ? autofill.data.data : [];
      this.autofillLoading = false;
    }, 500);

    this.handleAutofillSecond = debounce(async function (val) {
      this.autofillLoading = true;
      this.AutofillData = [];

      val={...val,...params};

      let autofill = await axios.post(this.baseUrl + "api/address/getAddress",
        val,
      );
      this.AutofillData = autofill.data.success ? autofill.data.data : [];
      this.autofillLoading = false;
    }, 500);

    if (this.fieldName == "PROVINCE_NAME") {
      this.handleAutofill();
    }

    if (this.fieldName == "CITY_NAME" && ((this.addressVal && this.addressVal.PROVINCE) || this.formMode == 'Progressive Form')) {
      this.handleAutofillSecond({ province: this.addressVal && this.addressVal.PROVINCE ? this.addressVal.PROVINCE : undefined });
    }
    
    if (this.fieldName == "DISTRICT_NAME" && ((this.addressVal && this.addressVal.PROVINCE && this.addressVal.CITY) || this.formMode == 'Progressive Form')) {
      this.handleAutofillSecond({
        province: this.addressVal && this.addressVal.PROVINCE ? this.addressVal.PROVINCE : undefined,
        city: this.addressVal && this.addressVal.CITY ? this.addressVal.CITY : undefined,
      });
    }

    if (this.addressVal) {
      this.payload = this.addressVal;
      this.customerAUTOFILL = this.payload.customerAUTOFILL+'_'+this.addressVal[this.fieldName]
    }
  },

  watch: {
    customerAUTOFILL(val){
      if(val){
        this.payload.customerAUTOFILL = val.split('_')[0]
        this.changeDestinationCode();
      }
    },
    addressVal(val) {
      if(val){
        if (this.fieldName == "PROVINCE_NAME") {
          this.handleAutofill(val["PROVINCE"]);
        } else {
          let search = {
            key: this.fieldName,
            value: val[this.fieldName.split("_")[0]],
          };
          this.handleAutofillSecond({ province: val["PROVINCE"], search });
        }     
        this.payload = val;
        if (this.fieldName == "PROVINCE_NAME") {
          this.payload.PROVINCE=val.PROVINCE_NAME;
          this.customerAUTOFILL=val.customerAUTOFILL;
        }
        if (this.fieldName == "CITY_NAME" && val.CITY_NAME) {
          this.payload.CITY=val.CITY_NAME;
          this.customerAUTOFILL=val.customerAUTOFILL;
        }
        if (this.fieldName == "DISTRICT_NAME" && val.DISTRICT_NAME) {
          this.payload.DISTRICT=val.DISTRICT_NAME;
          this.customerAUTOFILL=val.customerAUTOFILL;
        }
       
       
      }
     
    },
    "payload.customerAUTOFILL": {
      async handler() {
        this.changeDestinationCode();
      },
    },
    searchData: {
      async handler(val) {
        if (val.length > 3 || val.length==0) {
          if (this.fieldName == "PROVINCE_NAME") {
            this.handleAutofill(val);
          } else {
            let search = {
              key: this.fieldName,
              value: val,
            };
            this.handleAutofillSecond({ ...this.autoFillPayload, search });
          }
        }
      },
    },
    "addressVal.PROVINCE": {
      async handler(val) {
        if (this.fieldName == "CITY_NAME" && this.addressVal) {
          this.autoFillPayload = { province: val };
          this.handleAutofillSecond(this.autoFillPayload);
          // this.payload.CITY = '';
          // this.payload.DISTRICT= '';
        }
      },
    },
    // "AutofillData": {
    //   handler(val) {
    //     // console.log("here",this.$refs.carousel,this.images.length,this.variantImageIndex);
      
    //     if(val.length == 1 && this.fieldName == "PROVINCE_NAME"){
    //       this.customerAUTOFILL= val[0]._id+'_'+val[0][this.fieldName];
    //       this.changeDestinationCode()
    //     }     

    //     if(val.length == 1 && this.fieldName == "DISTRICT_NAME"){
    //       this.customerAUTOFILL= val[0]._id+'_'+val[0][this.fieldName];
    //       this.changeDestinationCode()
    //     }       

    //     if(val.length == 1 && this.fieldName == "CITY_NAME"){
    //       this.customerAUTOFILL= val[0]._id+'_'+val[0][this.fieldName];
    //       this.changeDestinationCode()       
    //     }
       
    //   },
    //   deep: true,
    // },
    // AutofillData(val){
    //   console.log("this.fieldName",this.fieldName,val);
    //   if(val.length == 1 && this.fieldName == "DISTRICT_NAME"){
    //     this.customerAUTOFILL= val[0]._id+'_'+val[0][this.fieldName];
    //     this.changeDestinationCode()
    //   }
    //   // if(val.length == 1 && this.fieldName == "CITY_NAME"){
    //   //   this.customerAUTOFILL= val[0]._id+'_'+val[0][this.fieldName];
    //   //   this.changeDestinationCode()
       
    //   // }
    // },
    "addressVal.CITY": {
      async handler(val) {
        if (
          this.addressVal &&
          this.addressVal.PROVINCE &&
          this.addressVal.CITY &&
          this.fieldName == "DISTRICT_NAME"
        ) {
          this.autoFillPayload = {
            province: this.addressVal.PROVINCE,
            city: val,
          };
          this.handleAutofillSecond(this.autoFillPayload);
          //this.payload.DISTRICT= '';
        }
      },
    },
  },
  computed: {
    selected() {
      if (this.fieldName == "PROVINCE_NAME") {
        return this.payload.PROVINCE
      }
      if (this.fieldName == "CITY_NAME") {
        return this.payload.CITY
      }
      if (this.fieldName == "DISTRICT_NAME") {
        return this.payload.DISTRICT
      }
      return ''
    },
    options() {
        return this.AutofillData.map(opt => ({
            label: this.fieldName && this.fieldName == "DISTRICT_NAME" ? `${opt[this.fieldName]} → ${opt.CITY_NAME} → ${opt.PROVINCE_NAME}` : this.fieldName ? opt[this.fieldName] : "",
            value: opt._id + '_' + opt[this.fieldName],
        }))
    },
  },
  methods: {
    changeDestinationCode() {
      let val = this.payload.customerAUTOFILL;
      if (this.AutofillData.length) {
        let find = this.AutofillData.find((one) => one._id == val);
        if (find) {
          this.payload.SUBDISTRICT = find.SUBDISTRICT_NAME;
          this.payload.DISTRICT =
            this.fieldName == "DISTRICT_NAME"
              ? find.DISTRICT_NAME
              : this.addressVal
              ? this.addressVal.DISTRICT
              : "";

          if (this.fieldName == "PROVINCE_NAME" || find.PROVINCE_NAME) {
            this.payload.PROVINCE = find.PROVINCE_NAME
            if (
              (find.CITY_NAME && find.CITY_NAME.length > 1) && 
              (find.DISTRICT_NAME && find.DISTRICT_NAME.length >1) &&
              find.ZIP_CODE.startsWith(this.keyword)
            ) {
              console.log({
                ZIP_CODE: find.ZIP_CODE,
                keyword: this.keyword,
                result: find.ZIP_CODE.startsWith(this.keyword)
              })
              this.payload.CITY = find.CITY_NAME
              this.payload.DISTRICT_NAME = find.DISTRICT_NAME
            }
          } else {
            this.payload.PROVINCE = this.addressVal ? this.addressVal.PROVINCE : ""
          }
              
          if (this.fieldName == "CITY_NAME" || find.CITY_NAME) {
            this.payload.CITY = find.CITY_NAME;
          } else {
            this.payload.CITY = this.addressVal ? this.addressVal.CITY : "";
          }
          this.payload.ZIP = find.ZIP_CODE;

          this.payload.DESTINATION_CODE_SI = find.DESTINATION_CODE_SI;
          this.payload.ORIGIN_CODE_SI = find.ORIGIN_CODE_SI;
          this.payload.closedSi = find.closedSi;
          this.payload.unsupportedSi = find.unsupportedSi;
          this.payload.CITY_NAME_SI = find.CITY_NAME_SI;

          this.payload.DESTINATION_CODE = find.DESTINATION_CODE;
          this.payload.ORIGIN_CODE = find.ORIGIN_CODE;

          this.payload.CODE_SAP = find.CODE_SAP;

          if (find.PROVINCE_NAME && find.CITY_NAME && find.DISTRICT_NAME) {
            this.payload.customerFULL_AUTOFILL =
              find.PROVINCE_NAME +
              ", " +
              find.CITY_NAME +
              ", " +
              find.DISTRICT_NAME +
              (this.dontIncludeSubdistrict ? "" : ", " + find.SUBDISTRICT_NAME);
          }
          this.$emit("onChange", this.payload);
          //this.getEstimate()
        }
      }
    },
    focusFields() {
      setTimeout(() => {
        this.$refs.orderInput &&
          this.$refs.orderInput.$el.querySelector("input").focus();
      }, 200)
    },
    resetFields() {
      if (this.fieldName == "PROVINCE_NAME") {
        this.customerAUTOFILL= "",
        this.payload.PROVINCE = "";
        this.payload.CITY = "";
        this.payload.DISTRICT = "";
        if(this.addressVal){       
          this.$emit('onChange', null)
        }
        
        // if(this.payload.PROVINCE == '') {
        //   this.customerAUTOFILL = '';
        // }
      }
      if (this.fieldName == "CITY_NAME") {
        this.customerAUTOFILL= "",
        this.payload.CITY = "";
        this.payload.DISTRICT = "";      
        // if(this.payload.CITY == '') {
        //   this.customerAUTOFILL = '';
        // }
        if(this.payload.PROVINCE == '') {
          this.autoFillPayload = undefined;
        }
      }
      if (this.fieldName == "DISTRICT_NAME") {
        this.payload.DISTRICT="";
        this.customerAUTOFILL = '';        
       // this.customerAUTOFILL = '';   
        // if(this.payload.DISTRICT == '') {
        //   this.customerAUTOFILL = '';         
        // }
        if(this.payload.PROVINCE == '' && this.payload.CITY == '') {
          this.autoFillPayload = undefined;
        }
      }
      if (this.searchData.length > 3) {
          if (this.fieldName == "PROVINCE_NAME") {
            this.handleAutofill(this.searchData);
          } else {
            let search = {
              key: this.fieldName,
              value: this.searchData,
            };
            this.handleAutofillSecond({ ...this.autoFillPayload, search });
          }
        }

    },
  },
  components: {
    Empty,
    Dropdown,
    Input,
  },
};
</script>

<template>
  <div id="sub-address" class="sub-address">   
    <Dropdown
      v-if="theme !== 'tuktuk'"
        v-model="customerAUTOFILL"
        :placeholder="placeholder"
        :rules="rules"
        :options="options"
        :label="showLabel ? fieldLabel : undefined"
        :name="fieldLabel"
        @opened="focusFields();"
        :use-bottom-sheet="$device ? $device.isMobile : false"
        :bottomSheetTitle="`Pilih ${fieldLabel}`"
        bottomSheetClass="bottom-sheet__sub-address-fill"
        :required="(rules || '').includes('required')"
    >
        <template #trigger="{ displayedValue }">
            <span>{{ selected || displayedValue }}</span>
        </template>
        <template #before-items>
            <Input ref='orderInput' class='device-ios w-100' v-model="searchData" type="text" />
        </template>
        <template #after-items>
            <span v-if="options.length === 0" class="address-search-placeholder">
                {{ autofillLoading
                    ? 'Searching...'
                    : searchData
                      ? 'Data tidak ditemukan'
                      : 'Ketik nama Kota/Kabupaten (minimal 4 huruf)'
                }}
            </span>
        </template>
    </Dropdown>
    <template v-if="theme === 'tuktuk'">
    <div
      :class="{
        'selected-address' : isLabel == 'showLabel', 
        'placeholder-text' : ((fieldName == 'PROVINCE_NAME' && payload.PROVINCE == '') || (payload.CITY == '' && fieldName == 'CITY_NAME') || (fieldName == 'DISTRICT_NAME' && payload.DISTRICT == ''))
      }"
      class="select-value-label"
    >
      {{
        fieldName == "PROVINCE_NAME"
          ? (payload.PROVINCE ? payload.PROVINCE : placeholder)
          : fieldName == "CITY_NAME" 
          ? (payload.CITY ? payload.CITY : placeholder)
          : fieldName == "DISTRICT_NAME"
          ? (payload.DISTRICT ? payload.DISTRICT : placeholder)
          : ""
      }}
    </div>
    <vs-select
      class="vs-form-control"
      @click="focusFields();resetFields();"
      :class="className"
      v-model="customerAUTOFILL"
    >  
      <vs-input
        ref="orderInput"
        class="device-ios"
        v-model="searchData"
        type="text"
      />
      <empty
        v-if="fieldName != 'PROVINCE_NAME'"
        :classProp="'p-1'"
        :data="
          AutofillData.length == 0
            ? fieldName == 'CITY_NAME'
              ? 'No Cities found'
              : fieldName == 'DISTRICT_NAME'
              ? 'No districts found'
              : ''
            : ''
        "
      />
      <empty
        v-else-if="autofillLoading"
        :classProp="'p-1'"
        :data="'Searching'"
      />
      <vs-option
        :key="opt._id+'_'+opt[fieldName]"
        v-for="opt in AutofillData"
        :label="opt.PROVINCE_NAME"
        :value="opt._id+'_'+opt[fieldName]"
      >
        <!-- {{ fieldName ? opt[fieldName] : "" }} -->
        {{ fieldName && fieldName == "DISTRICT_NAME" ? `${opt[fieldName]} → ${opt.CITY_NAME} → ${opt.PROVINCE_NAME}` : fieldName ? opt[fieldName] : "" }}
      </vs-option>
    </vs-select>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.sub-address {
  scroll-margin: 150px;

  &::v-deep {
    .classic-form__dropdown {
      label {
        opacity: 1 !important;
      }
      &__trigger {
          height: 44px !important;
          &::after {
            background-position: right 8px top 10px !important;
          }
      }
      .classic-form__input {
          input {
              font-size: 14px !important;
              height: 40px !important;
              padding: 10px 36px 10px 12px !important;
              background-image: url("data:image/svg+xml,%0A%3Csvg width='20' height='21' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14.1057 14.688L17 17.488M16.0667 10.0214C16.0667 13.6296 13.1416 16.5547 9.53333 16.5547C5.92507 16.5547 3 13.6296 3 10.0214C3 6.41311 5.92507 3.48804 9.53333 3.48804C13.1416 3.48804 16.0667 6.41311 16.0667 10.0214Z' stroke='%236C7E95' stroke-linecap='round'/%3E%3C/svg%3E%0A") !important;
              background-position: right 12px top 10px !important;
              background-repeat: no-repeat !important;
              outline-color: #E0E9F4 !important;
              outline-width: 1px !important;
              outline-offset: -1px !important;
              box-shadow: 0px 1px 2px 0px #1018280D;
          }
      }
      .address-search-placeholder {
          margin-top: 6px;
          color: #6C7E95;
          font-size: 12px;
          font-weight: 400;
          line-height: 18px;
      }
    }
  }
}
.placeholder-text {
  opacity: 0.4;
}
</style>

<style lang="scss">
.bottom-sheet__sub-address-fill {
    .classic-form__input {
      input {
        font-size: 14px !important;
        height: 40px !important;
        padding: 10px 36px 10px 12px !important;
        background-image: url("data:image/svg+xml,%0A%3Csvg width='20' height='21' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14.1057 14.688L17 17.488M16.0667 10.0214C16.0667 13.6296 13.1416 16.5547 9.53333 16.5547C5.92507 16.5547 3 13.6296 3 10.0214C3 6.41311 5.92507 3.48804 9.53333 3.48804C13.1416 3.48804 16.0667 6.41311 16.0667 10.0214Z' stroke='%236C7E95' stroke-linecap='round'/%3E%3C/svg%3E%0A") !important;
        background-position: right 12px top 10px !important;
        background-repeat: no-repeat !important;
        outline-color: #E0E9F4 !important;
        outline-width: 1px !important;
        outline-offset: -1px !important;
        box-shadow: 0px 1px 2px 0px #1018280D;

        &:focus {
          outline-color: #E0E9F4 !important;
        }
      }
    }
    .address-search-placeholder {
        margin-top: 6px;
    }
    .device-ios {
      input {
        font-size: 16px !important;
      }
    }
}
</style>